/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type {
  GroundingMenuSubmenuHeaderSlots,
  GroundingMenuSubmenuHeaderState,
} from './GroundingMenuSubmenuHeader.types';

/**
 * Render the final JSX of GroundingMenuSubmenuHeader
 */
export const renderGroundingMenuSubmenuHeader_unstable = (state: GroundingMenuSubmenuHeaderState): JSXElement => {
  assertSlots<GroundingMenuSubmenuHeaderSlots>(state);

  const backButton = state.backButton && <state.backButton />;

  return (
    <state.root>
      {state.backButtonTooltip ? <state.backButtonTooltip>{backButton}</state.backButtonTooltip> : backButton}
      {state.primaryText && <state.primaryText />}
      {state.secondaryText && <state.secondaryText />}
    </state.root>
  );
};
